'use client';

import Image from 'next/image';
import { ChevronDown, MessageCircleQuestion } from 'lucide-react';

const faqs = [
  {
    question:
      'Does Avetium Payroll handle both Nigerian and Ghanaian statutory requirements?',
    answer:
      'Yes. Avetium Payroll is designed to support payroll processing and statutory requirements for businesses operating across Nigeria and Ghana.',
  },
  {
    question:
      'Can I customise payroll calculations to fit my company’s policy?',
    answer:
      'Yes. Payroll calculations can be configured to reflect your company’s policies, allowances, deductions, benefits and other payroll rules.',
  },
  {
    question: 'Is employee payroll data secure?',
    answer:
      'Yes. Employee payroll information is protected using appropriate security controls designed to keep sensitive payroll data safe.',
  },
  {
    question: 'Can employees access their own payslips?',
    answer:
      'Yes. Employees can access their payslips through the employee experience, making it easy for them to view their payroll information.',
  },
  {
    question: 'Does it integrate with the tools we already use?',
    answer:
      'Yes. Avetium Payroll is designed to work alongside the tools and workflows businesses already use.',
  },
];

export default function FAQPage() {
  return (
    <main className="faq-page">

      {/* =========================================
          FAQ HERO
      ========================================= */}
      <section className="faq-hero">
        <div className="faq-hero-content">
          <h1>FAQ's</h1>
          <p>Got questions?</p>
        </div>
      </section>

      {/* =========================================
          FAQ CONTENT
      ========================================= */}
      <section className="faq-section">

        <div className="faq-intro">

          <div className="faq-intro-label">
            <MessageCircleQuestion size={22} />
            <span>FAQs</span>
          </div>

          <h2>
            Got questions about payroll in Nigeria & Ghana?
          </h2>

        </div>

        <div className="faq-content">

          {/* IMAGE */}
          <div className="faq-image-wrapper">
            <Image
              src="/images/man-faq.png"
              alt="Payroll support representative"
              fill
              className="faq-image"
              sizes="(max-width: 991px) 100vw, 45vw"
            />
          </div>

          {/* QUESTIONS */}
          <div className="faq-list">

            <div className="faq-list-heading">
              <MessageCircleQuestion size={30} />
              <span>Frequently Asked Questions</span>
            </div>

            <div className="faq-items">

              {faqs.map((faq, index) => (
                <details
                  className="faq-item"
                  key={index}
                >
                  <summary>
                    <span>{faq.question}</span>

                    <ChevronDown
                      size={18}
                      className="faq-chevron"
                    />
                  </summary>

                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                </details>
              ))}

            </div>

          </div>

        </div>

      </section>

    </main>
  );
}